import type { ChargingStation, ChargingStationMetadata } from '../../../src/store/facade/facadeApiV3';
import {
    ChargePointParkingScenario,
    ChargingStationAmenities,
    ConnectorPlugType,
    ConnectorPowerType,
    ConnectorStandard,
    ConnectorStatus,
    ContractType,
    Currency,
    DayOfWeek,
    StationContracts,
    TruckClassification,
} from '../../../src/store/facade/facadeApiV3';

export const chargePointData1 = {
    id: '07765f10-d848-40eb-953f-e81878bd34c9',
    operator: {
        id: '2aefcdfb-b632-420b-85af-c5c07b3e6322',
        name: 'BP Europa SE',
    },
    name: 'DE | Aral 0F150 | Bahnhofstraße 53, 55494 Rheinböllen | TRUCK - DC #02',
    location: {
        latitude: 49.996284,
        longitude: 7.683968,
    },
    maxPower: 300,
    supportPhone: '+49 800 135 351 1',
    chargePoints: [
        {
            chargePointId: 'cp-1',
            supportsRemoteAuthentication: false,
            connectors: [
                {
                    id: '797633c4-6f94-4415-a84b-534f814574ae',
                    evseId: 'DE*BPE*E0F150*02*06',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 100,
                    prices: [
                        { contractType: ContractType.Tcs, price: '0.69', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.57', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.63', currency: Currency.Eur },
                    ],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'DE*BPE*E0F150*02*04',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [
                        { contractType: ContractType.Tcs, price: '0.69', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.57', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.63', currency: Currency.Eur },
                    ],
                },
            ],
        },
    ],
} as ChargingStation;

export const chargePointData1Metadata: ChargingStationMetadata = {
    id: chargePointData1.id,
    name: chargePointData1.name,
    tcsId: 'tcs-uu-id',
    operator: chargePointData1.operator,
    location: chargePointData1.location,
    maxPower: chargePointData1.maxPower,
    truckClassification: TruckClassification.TruckReady,
    numberOfConnectors: 2,
    connectorsPowers: [100, 300],
};

export const chargePointData2 = {
    id: '430c2be9-b6ea-44fc-bd4b-fceadb204b39',
    operator: {
        id: '83f23926-43ae-4e43-8b3c-d2ad60cc1fb8',
        name: 'Proviridis',
    },
    name: 'Proviridis/6426d2f8e68d7362559e5b6f',
    location: {
        latitude: 46.228058,
        longitude: 5.259945,
    },
    maxPower: 300,
    supportPhone: '',
    chargePoints: [
        {
            chargePointId: 'cp-2',
            supportsRemoteAuthentication: false,
            connectors: [
                {
                    id: 'c509ceba-8d80-4701-8587-d5a6fd650eb9',
                    evseId: 'FR*PVD*EVG*BEB01*AD01*3',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 450,
                    prices: [],
                },
                {
                    id: '95582f12-dc3b-46b5-a56a-46f670f2a130',
                    evseId: 'FR*PVD*EVG*BEB01*AD02*1',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 350,
                    prices: [],
                },
                {
                    id: '87d9803d-f974-4241-be13-7ad5dc870bcf',
                    evseId: 'FR*PVD*EVG*BEB01*AD02*3',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 400,
                    prices: [],
                },
                {
                    id: '296a436d-0762-4f4f-9ac9-4cd25d2c4e0f',
                    evseId: 'FR*PVD*EVG*BEB01*AD01*1',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 450,
                    prices: [],
                },
                {
                    id: 'f81d4614-1bc6-4cc5-a150-969c8e05e496',
                    evseId: 'FR*PVD*EVG*BEB01*AD03*3',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    prices: [],
                },
                {
                    id: '7a1b1f0d-a3a2-4db3-8a00-b1d923e72b46',
                    evseId: 'FR*PVD*EVG*BEB01*AD03*1',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [],
                },
            ],
        },
    ],
} as ChargingStation;

export const chargePointData2Metadata: ChargingStationMetadata = {
    id: chargePointData2.id,
    name: chargePointData2.name,
    tcsId: 'tcs-uu-id',
    operator: chargePointData2.operator,
    location: chargePointData2.location,
    maxPower: chargePointData2.maxPower,
    truckClassification: TruckClassification.TruckReady,
    numberOfConnectors: 6,
    connectorsPowers: [450, 350, 400, 450, 0, 300],
};

export const chargePointData3 = {
    id: '430c2be9-b6ea-44fc-bd4b-fceadb204b37',
    operator: {
        id: '83f23926-43ae-4e43-8b3c-d2ad60cc1fb8',
        name: 'Proviridis',
    },
    name: 'third',
    location: {
        latitude: 46.228058,
        longitude: 5.259945,
    },
    maxPower: 300,
    supportPhone: '',
    chargePoints: [],
} as ChargingStation;

export const chargePointData4 = {
    id: '002a1572-7eb5-4798-ab86-c7aaa45f7f3a',
    operator: {
        id: '9cf0ecc9-8996-4da3-b88f-769175a414eb',
        name: 'IONITY GmbH',
    },
    name: 'IONITY Orléans Nord - CCS #01',
    location: {
        latitude: 47.948715,
        longitude: 1.859535,
    },
    maxPower: 350,
    supportPhone: '',
    chargePoints: [
        {
            chargePointId: 'cp-4',
            supportsRemoteAuthentication: false,
            connectors: [
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a3',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Available,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 350,
                    prices: [
                        { contractType: ContractType.Tcs, price: '0.69', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.57', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.63', currency: Currency.Eur },
                    ],
                },
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a2',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 350,
                    prices: [],
                },
            ],
        },
    ],
} as ChargingStation;

export const chargePointData5 = {
    id: 'a1b2c3d4-5678-90ab-cdef-111111111111',
    operator: {
        id: '9cf0ecc9-8996-4da3-b88f-769175a414eb',
        name: 'IONITY GmbH',
    },
    name: 'IONITY Orléans Nord - CCS #02',
    address: {
        name: 'Vinci Orleans Nord',
        street: '39 Rue Henri Becquerel',
        city: 'Saran',
        countryCode: 'FR',
        postalCode: '45770',
    },
    location: {
        latitude: 47.948715,
        longitude: 1.859535,
    },
    maxPower: 350,
    supportPhone: '',
    hasADRRestrictions: true,
    stationContracts: [StationContracts.Tcs],
    amenities: [
        ChargingStationAmenities.Shower,
        ChargingStationAmenities.Toilets,
        ChargingStationAmenities.Hotel,
        ChargingStationAmenities.Restaurant,
        ChargingStationAmenities.TrailerParking,
        ChargingStationAmenities.VideoSurveillance,
    ],
    openingHours: {
        open24x7: false,
        chargingWhenClosed: false,
        regularSchedule: [
            { dayOfWeek: DayOfWeek.Monday, time: { timeFrom: '08:00', timeTo: '22:00' } },
            { dayOfWeek: DayOfWeek.Tuesday, time: { timeFrom: '08:00', timeTo: '22:00' } },
            { dayOfWeek: DayOfWeek.Wednesday, time: { timeFrom: '08:00', timeTo: '22:00' } },
            { dayOfWeek: DayOfWeek.Thursday, time: { timeFrom: '08:00', timeTo: '22:00' } },
            { dayOfWeek: DayOfWeek.Friday, time: { timeFrom: '08:00', timeTo: '22:00' } },
            // Saturday and Sunday intentionally omitted to represent closed days
        ],
    },
    chargePoints: [
        {
            chargePointId: '9cf0ecc9-8996-4da3-b88f-769175a414eb',
            supportsRemoteAuthentication: false,
            parkingRestrictions: {
                parkingScenario: ChargePointParkingScenario.DriveThrough,
                blockSeveralParkingSpots: true,
                parkingLotLength: 25,
                parkingLotWidth: 12,
            },
            vehicleRestrictions: {
                heightRestriction: 2.8,
                canChargeWithTrailer: true,
            },
            connectors: [
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a3',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Available,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 350,
                    prices: [
                        {
                            contractType: ContractType.Here,
                            price: '0.69',
                            currency: Currency.Eur,
                        },
                        {
                            contractType: ContractType.Tcs,
                            price: '0.57',
                            currency: Currency.Eur,
                        },
                        {
                            contractType: ContractType.Tcs,
                            price: '0.63',
                            currency: Currency.Eur,
                        },
                    ],
                },
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a2',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 350,
                    prices: [],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'DE*BPE*E0F150*02*04',
                    status: ConnectorStatus.Occupied,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'PA*BPE*E0F150*02*04',
                    status: ConnectorStatus.Unavailable,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [],
                },
            ],
        },
        {
            chargePointId: '9cf0ecc9-8996-4da3-b88f-769175a414eb',
            supportsRemoteAuthentication: false,
            parkingRestrictions: {
                parkingScenario: ChargePointParkingScenario.Unknown,
                blockSeveralParkingSpots: true,
                parkingLotLength: 25,
                parkingLotWidth: 15,
            },
            vehicleRestrictions: {
                heightRestriction: 3.8,
                canChargeWithTrailer: true,
            },
            connectors: [
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a3',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Available,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    powerType: ConnectorPowerType.Dc,
                    maxPower: 350,
                    prices: [
                        {
                            contractType: ContractType.Tcs,
                            price: '0.69',
                            currency: Currency.Eur,
                        },
                        {
                            contractType: ContractType.Tcs,
                            price: '0.57',
                            currency: Currency.Eur,
                        },
                        {
                            contractType: ContractType.Tcs,
                            price: '0.63',
                            currency: Currency.Eur,
                        },
                    ],
                },
                {
                    id: '3d177670-534b-4742-aa3e-14d1220276a2',
                    evseId: 'FR*IOY*E435501',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 350,
                    prices: [],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'DE*BPE*E0F150*02*04',
                    status: ConnectorStatus.Occupied,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'PA*BPE*E0F150*02*04',
                    status: ConnectorStatus.Unavailable,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [],
                },
            ],
        },
    ],
} as ChargingStation;

export const chargePointData5Metadata: ChargingStationMetadata = {
    id: chargePointData5.id,
    name: chargePointData5.name,
    tcsId: 'tcs-uu-id',
    operator: chargePointData5.operator,
    location: chargePointData5.location,
    address: chargePointData5.address,
    maxPower: chargePointData5.maxPower,
    truckClassification: TruckClassification.TruckReady,
    numberOfConnectors: 8,
    connectorsPowers: [350, 350, 300, 300, 350, 350, 300, 300],
};

export const chargePointData6 = {
    id: 'a1b2c3d4-5678-90ab-cdef-222222222222',
    operator: {
        id: '2aefcdfb-b632-420b-85af-c5c07b3e6322',
        name: 'BP Europa SE',
    },
    name: 'DE | Aral 0F150 | Bahnhofstraße 53, 55494 Rheinböllen | TRUCK - DC #02',
    location: {
        latitude: 49.996284,
        longitude: 7.683968,
    },
    maxPower: 300,
    supportPhone: '+49 800 135 351 1',
    hasADRRestrictions: true,
    amenities: [
        ChargingStationAmenities.Shower,
        ChargingStationAmenities.Toilets,
        ChargingStationAmenities.Hotel,
        ChargingStationAmenities.Restaurant,
        ChargingStationAmenities.TrailerParking,
    ],
    openingHours: {
        open24x7: true,
        chargingWhenClosed: false,
    },
    chargePoints: [
        {
            chargePointId: '9cf0ecc9-8996-4da3-b88f-769175a414eb',
            supportsRemoteAuthentication: false,
            parkingRestrictions: {
                parkingScenario: ChargePointParkingScenario.DriveThrough,
                blockSeveralParkingSpots: true,
                parkingLotLength: 25,
                parkingLotWidth: 12,
            },
            vehicleRestrictions: {
                heightRestriction: 2.8,
                canChargeWithTrailer: true,
            },
            connectors: [
                {
                    id: '797633c4-6f94-4415-a84b-534f814574ae',
                    evseId: 'DE*BPE*E0F150*02*06',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 100,
                    prices: [
                        { contractType: ContractType.Tcs, price: '0.69', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.57', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.63', currency: Currency.Eur },
                    ],
                },
                {
                    id: '640ee297-460e-4586-9c73-2e46b979132e',
                    evseId: 'DE*BPE*E0F150*02*04',
                    status: ConnectorStatus.Unknown,
                    standard: ConnectorStandard.Iec62196T2Combo,
                    plugType: ConnectorPlugType.Ccs2,
                    maxPower: 300,
                    prices: [
                        { contractType: ContractType.Tcs, price: '0.69', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.57', currency: Currency.Eur },
                        { contractType: ContractType.Tcs, price: '0.63', currency: Currency.Eur },
                    ],
                },
            ],
        },
    ],
} as ChargingStation;

export const chargePointData6Metadata: ChargingStationMetadata = {
    id: chargePointData6.id,
    name: chargePointData6.name,
    tcsId: 'tcs-uu-id',
    operator: chargePointData6.operator,
    location: chargePointData6.location,
    maxPower: chargePointData6.maxPower,
    truckClassification: TruckClassification.TruckReady,
    numberOfConnectors: 2,
    connectorsPowers: [100, 300],
};
